import React from 'react';
import { useTranslation } from 'react-i18next';

// material-ui icons
import Close from "@material-ui/icons/Close";

// material-ui components
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Tooltip from "@material-ui/core/Tooltip";
import RefreshIcon from '@material-ui/icons/Refresh';

// core components
import Button from "beaktShared/components/CustomButtons/Button.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";

// Outros components
// import QRCode from "qrcode.react"; // TODO: Fix QRCode import - webpack module resolution issue with CommonJS

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/finalizacaoVenda.js";
const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});


export default function QRCodeBeaktPix({ qrCodeBeaktPix_value, showModal, closeModal, atualizarStatus }) {

    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Dialog
            classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal }}
            open={showModal}
            TransitionComponent={Transition}
            keepMounted
            onClose={closeModal}
            aria-labelledby="classic-modal-slide-title"
            aria-describedby="classic-modal-slide-description"
        >
            <DialogTitle
                id="classic-modal-slide-title"
                disableTypography
                className={classes.modalHeader}
                style={{ background: '#5c4477' }}
            >
                <Button
                    justIcon
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    color="transparent"
                    onClick={closeModal}
                >
                    <Close className={classes.modalClose} />
                </Button>
                <h4 className={classes.modalTitle} style={{color:'white'}}>QR Code PIX </h4>
            </DialogTitle>
            <DialogContent id="classic-modal-slide-description"
                className={classes.modalBody} style={{ background: '#f0f0f0' }}
            >
                <GridContainer>
                    <GridItem xs={6}><center><div style={{padding: '20px', color: '#999'}}>QR Code [Temporariamente desabilitado]</div></center></GridItem>
                    <GridItem xs={6}>
                        <center>
                            <label>Após o cliente efetuar a leitura do QR Code, clique em "Atualizar Status" para verificar o pagamento.</label>
                            <Button color="warning"
                                onClick={atualizarStatus}>
                                {t('button.update_status')}
                            </Button>
                        </center>
                    </GridItem>
                </GridContainer>
            </DialogContent>
        </Dialog>
    )
}